export default "__VITE_ASSET__f5334eaa__"